import React, { useCallback, useEffect, useRef, useState } from "react";
import BaseApi from "../../Http/BaseApi";

export default function MathCaptchaField({ panel = "staff", value, onChange }) {
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await BaseApi(panel).get("captcha");
      setImage(res.data.image_base64 || "");
      onChangeRef.current?.({
        captcha: "",
        captcha_key: res.data.captcha_key || "",
      });
    } catch (_) {
      setImage("");
      onChangeRef.current?.({ captcha: "", captcha_key: "" });
    } finally {
      setLoading(false);
    }
  }, [panel]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <div className='mt-4 space-y-2'>
      <label className='block text-sm font-medium text-gray-700'>
        Enter the result of the following calculation:
      </label>
      <div className='flex items-center gap-3'>
        {image ? (
          <img
            src={image}
            alt='Captcha'
            className='h-14 border border-gray-200 rounded bg-gray-50'
          />
        ) : (
          <div className='flex items-center justify-center w-48 h-14 text-xs text-gray-400 border border-dashed rounded'>
            {loading ? "Loading..." : "Unavailable"}
          </div>
        )}
        <button
          type='button'
          onClick={refresh}
          className='px-3 py-2 text-xs font-medium text-indigo-700 bg-indigo-50 border border-indigo-100 rounded hover:bg-indigo-100'
          title='Refresh captcha'
        >
          Refresh
        </button>
      </div>
      <input
        type='text'
        value={value?.captcha || ""}
        onChange={(e) =>
          onChangeRef.current?.({
            captcha: e.target.value,
            captcha_key: value?.captcha_key || "",
          })
        }
        placeholder='Enter captcha answer'
        className='relative block w-full px-3 py-2 text-gray-900 placeholder-gray-500 border border-gray-300 rounded-md appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
        autoComplete='off'
        required
      />
    </div>
  );
}
